import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { uniqBy } from "lodash";
import { helpers, http } from "../../common/lib";
import config from "../../config";
import { db } from "../../common/lib";
import { get, set } from "idb-keyval";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

const reducer = (aggregate: any, [key, value]: any) => ({
    ...aggregate,
    [key]: helpers.list.getReducer({}, value),
});

function* getRequest(action) {
    try {
        const { audits } = action.payload;
        const orgs = uniqBy(audits, "organisation.id");
        /** Construct url */
        const orgCalls = orgs.map((item) => {
            const { id } = item.organisation;
            return `${config.api.paths.typesList}?organisation=${id}`;
        });

        /** Call orgs url */
        const result = yield all(
            orgCalls.map((orgItem) => call(http.authorized.get, orgItem))
        );

        /** Construct for idb with orgIds  */
        const typeListDB = result.map((item, index) => {
            return {
                orgId: orgs[index].organisation.id,
                typesList: item.data,
            };
        });

        yield call(set, db.types.typesList, typeListDB);
        yield put(actionCreators.getSuccess(typeListDB));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("types list get", {
            error,
            errStr,
            actionPayload: action.payload,
        });
        yield put(actionCreators.getFailure(errStr));
    }
}
function* selectRequest() {
    try {
        const { audits } = yield select((state) => state);
        const { id } = audits.item.organisation;
        let typesLits = (yield call(get, db.types.typesList)) || [];

        let data = typesLits.find((item) => item.orgId === id);
        data = Object.entries(data.typesList).reduce(reducer, {});

        yield put(actionCreators.selectSuccess(data));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("types list select", {
            error,
        });
        yield put(actionCreators.selectFailure(errStr));
    }
}

export { getRequest, selectRequest };

export default (function* () {
    yield all([
        takeLatest(actionTypes.TYPES_LIST_GET_REQUEST, getRequest),
        takeLatest(actionTypes.TYPES_LIST_SELECT_REQUEST, selectRequest),
    ]);
})();
